var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "mobile" },
    [
      _c("nav", { staticClass: "nav" }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.isPreviewActive,
                expression: "isPreviewActive",
              },
            ],
            staticClass: "nav__prev",
            on: {
              click: function ($event) {
                _vm.isPreviewActive = false
              },
            },
          },
          [_c("i", { staticClass: "isif isif-arrow-left" })]
        ),
        _vm._v(" "),
        !_vm.disableClose
          ? _c(
              "div",
              {
                staticClass: "nav__close",
                on: {
                  click: function ($event) {
                    return _vm.$emit("close")
                  },
                },
              },
              [_c("i", { staticClass: "isif isif-close" })]
            )
          : _vm._e(),
      ]),
      _vm._v(" "),
      _vm.tags.some(_vm.isJoorActionTag) && _vm.isInJoorPlatform
        ? [
            _c("div", { staticClass: "marker-select" }, [
              _c(
                "select",
                {
                  staticClass: "marker-info-select",
                  attrs: { name: "price-type-select" },
                  domProps: { value: _vm.currentPriceType.id },
                  on: { change: _vm.updatePriceType },
                },
                _vm._l(_vm.availablePriceType, function (price) {
                  return _c(
                    "option",
                    { key: price.id, domProps: { value: price.id } },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(price.currency_code) +
                          "\n        "
                      ),
                    ]
                  )
                }),
                0
              ),
            ]),
          ]
        : _vm._e(),
      _vm._v(" "),
      !_vm.isPreviewActive
        ? _c(
            "main-view",
            _vm._b(
              {
                staticClass: "main-view",
                attrs: {
                  "i18n-field-value": _vm.i18nFieldValue,
                  "get-action-mutate": _vm.getActionMutate,
                  "available-price-type": _vm.availablePriceType,
                },
                on: {
                  preview: function ($event) {
                    _vm.isPreviewActive = _vm.whiteLabelCeline
                    _vm.index = $event
                  },
                },
              },
              "main-view",
              _vm.$props,
              false
            )
          )
        : _c("image-view", {
            staticClass: "image-view",
            attrs: { tags: _vm.tags, index: _vm.index },
            on: {
              "update:index": function ($event) {
                _vm.index = $event
              },
            },
          }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }